import gql from 'graphql-tag'
import { ICreateUserInput } from '../types/CreateUserInput'
import { useMutation } from '@apollo/client'

const CREATE_USER_MUTATION = gql`
  mutation createUser($user: CreateUserInput!) {
    admin {
      createUser(data: $user) {
        id
      }
    }
  }
`

interface IResponse {
  admin: {
    createUser: {
      id: number
    }
  }
}

interface IVariables {
  user: ICreateUserInput
}
// TODO rewrite to a GQL file
export const useCreateUserMutation = () =>
  useMutation<IResponse, IVariables>(CREATE_USER_MUTATION)
